module.exports = __webpack_public_path__ + "img/television0.c0c11dea.png";